import {
  Button,
  Box,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuOptionGroup,
  MenuItemOption,
  Input,
  InputGroup,
  InputLeftElement,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Tag,
} from "@chakra-ui/react";
import { AiOutlineSearch } from "react-icons/ai";
import { BiFilter } from "react-icons/bi";
import TableContents from "components/PaginationTable";
import { ImCheckmark } from "react-icons/im";
import { GiCancel } from "react-icons/gi";
import React, { useState } from "react";
import { useQueryWrapper } from "services/apiHelper";
import { scriptsRequest } from "services/request";
import { statusOBJ } from "utils/constants";
import dayjs from "dayjs";
import { PROTECTED_PATHS } from "routes/pagePath";
import { useNavigate } from "react-router-dom";
import { FaEye, FaPencilAlt } from "react-icons/fa";
import { CheckIcon, WarningIcon } from "@chakra-ui/icons";

const TestApi = () => {
  const { APPROVED, PENDING, REJECTED } = statusOBJ;
  const history = useNavigate();
  const [, setCurrentScript] = useState({});
  const COLUMNS = [
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Composer",
      accessor: "composer",
    },
    {
      Header: "Uploaded By",
      accessor: "user.userName",
    },
    {
      Header: "Published",
      Cell: function verified({ cell }: any) {
        const status = cell.row.original.isVerified;
        return (
          <Tag
            borderRadius="full"
            bg={status === APPROVED ? "#BBE5B3" : status === REJECTED ? "orangered" : "#FFEA8A"}
            color="#414F3E"
            fontSize="xs"
            textTransform="capitalize"
          >
            {status === APPROVED ? APPROVED : status === REJECTED ? REJECTED : PENDING}
          </Tag>
        );
      },
    },
    {
      Header: "Uploaded On",
      Cell: function uploaded({ cell }: any) {
        return <div> {dayjs(cell.row.original.createdAt).format("MMM D YYYY")}</div>;
      },
    },

    {
      Header: "Category",
      accessor: "category",
    },
    {
      Header: "Edit",
      Cell: function edit({ cell }) {
        return (
          <Button
            onClick={() => {
              // dispatch(editScript(cell.row.original));
              history(`${PROTECTED_PATHS.NEW_EDIT_SCRIPT}?edit=${cell.row.original.slug}`);
            }}
          >
            <FaPencilAlt />
          </Button>
        );
      },
    },

    {
      Header: "Approve",
      Cell: ({ cell }) => (
        <Button
          bg="green"
          onClick={() => {
            setCurrentScript(cell.row.original);
            onOpen();
          }}
        >
          <ImCheckmark />
        </Button>
      ),
    },
    {
      Header: "View",
      Cell: ({ cell }: any) => (
        <Button
          variant="secondary"
          onClick={() => {
            history(`/scripts/${cell.row.original.slug}`);
          }}
        >
          <FaEye />
        </Button>
      ),
    },
    {
      Header: "Reject",
      Cell: ({ cell }: any) => (
        <Button bg="orangered" onClick={onOpenReject}>
          <GiCancel />
        </Button>
      ),
    },
  ];

  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isOpenReject, onOpen: onOpenReject, onClose: onCloseReject } = useDisclosure();

  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const [subInfo, setSubInfo] = useState<any>([]);

  const { data, isLoading } = useQueryWrapper("GET_ADMIN_SCRIPTS", scriptsRequest.SCRIPTS_ADMIN, {
    onSuccess: (data) => {
      setSubInfo(data);
    },
  });

  return (
    <>
      <Box
        mt="4"
        ml={{
          base: "0",
          md: "0",
          lg: "0",
          xl: "0",
          "2xl": "210px",
        }}
        maxW={{
          "2xl": "container.xl",
          xl: "container.xl",
          lg: "container.md",
          md: "container.md",
        }}
      >
        <Text as="h1" fontSize="1.3rem" color="#4e6e97" mt="4" ml="4" textTransform="uppercase">
          Admin view all
        </Text>
        <Box p={"0 10px"} mt="2">
          <InputGroup mb={[8, 8, null]} w="100%">
            <InputLeftElement pointerEvents="none">
              <AiOutlineSearch color="gray.300" />
            </InputLeftElement>
            <Input type="search" placeholder="Search your scripts" />
          </InputGroup>
        </Box>
        <Box textAlign="right">
          <Menu>
            <MenuButton
              mx={2}
              as={Button}
              aria-label="Filter scripts"
              leftIcon={<BiFilter />}
              variant="outline"
              fontWeight="normal"
            ></MenuButton>
            <MenuList minWidth="240px">
              <MenuOptionGroup defaultValue="all" title="Filter" type="radio">
                <MenuItemOption value="All">All</MenuItemOption>
                <MenuItemOption value="Pending">Pending</MenuItemOption>
                <MenuItemOption value="Published">Published</MenuItemOption>
                <MenuItemOption value="Cancelled">Cancelled</MenuItemOption>
              </MenuOptionGroup>
            </MenuList>
          </Menu>
        </Box>
        <Box>
          {isLoading ? (
            <div>Loading...please be patient</div>
          ) : (
            subInfo.map((val: any, index) => <div key={index}></div>)
          )}
        </Box>

        <Box p="4">
          <TableContents data={data || []} columns={COLUMNS} loading={false} />
        </Box>
      </Box>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent alignItems="center">
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Box
              borderRadius="50px"
              border="1px double #B8F7BC"
              mt="20px"
              w="100px"
              h="100px"
              position="relative"
              ml="70px"
            >
              <CheckIcon w="100px" h="100px" color="#B8F7BC" px="20px" position="absolute" />
            </Box>
            <Text fontSize="20px" fontWeight="800" ml="60px" mt="30px">
              Verify Script
            </Text>
            <Text mt="30px">You will not be able to revert this!!!</Text>
          </ModalBody>
          <ModalFooter>
            <Button mr={3}>Yes verify it</Button>
            <Button onClick={onClose} background="red">
              cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpenReject}
        onClose={onCloseReject}
      >
        <ModalOverlay />
        <ModalContent alignItems="center">
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Box
              borderRadius="50px"
              border="1px double #F5897E "
              mt="20px"
              w="100px"
              h="100px"
              position="relative"
              ml="70px"
            >
              <WarningIcon w="100px" h="100px" color="#F5897E " px="20px" position="absolute" />
            </Box>
            <Text fontSize="20px" fontWeight="800" ml="60px" mt="30px">
              Reject Script
            </Text>
            <Text mt="30px">You will not be able to revert this!!!</Text>
          </ModalBody>
          <ModalFooter>
            <Button mr={3}>Yes reject it</Button>
            <Button onClick={onCloseReject} background="red">
              cancel
            </Button>
          </ModalFooter>
        </ModalContent>
        ;
      </Modal>
    </>
  );
};

export default TestApi;
